import { render, staticRenderFns } from "./CARD.vue?vue&type=template&id=772d7dcf&scoped=true&"
import script from "./CARD.vue?vue&type=script&lang=js&"
export * from "./CARD.vue?vue&type=script&lang=js&"
import style0 from "./CARD.vue?vue&type=style&index=0&id=772d7dcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772d7dcf",
  null
  
)

export default component.exports